var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"p-home-heading"},[_vm._v("Onur Yüktaşır"),_c('br'),_vm._v("Front-end & Creative Developer")])}]

export { render, staticRenderFns }